import { Route, Switch } from "react-router-dom";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { lazyWithRetry } from "@monorepo/helpers";

import LegalAgreements from "components/Profile/LegalAgreements/LegalAgreements";

const Personal = lazyWithRetry(() => import("components/Profile/Personal/Personal"));
const Settings = lazyWithRetry(() => import("components/Profile/Settings/Settings"));
const CampaignFunnelPage = lazyWithRetry(() => import("components/Profile/Campaign/CampaignFunnel/CampaignFunnelPage"));

export const Profile = () => {
  return (
    <Switch>
      <Route path={routeConfig.dashboard.profile.personal}>
        <Personal />
      </Route>
      <Route path={routeConfig.dashboard.profile.agreements}>
        <LegalAgreements />
      </Route>
      <Route path={routeConfig.dashboard.profile.settings}>
        <Settings />
      </Route>
      <Route path={routeConfig.dashboard.profile.campaign}>
        <CampaignFunnelPage />
      </Route>
    </Switch>
  );
};
